<script lang="ts">
  import type { Product } from "../../helpers/types";
  import InputContainer from "../atoms/InputContainer.svelte";
  import Radio from "../atoms/Radio.svelte";
  import PriceInfo from "../molecules/PriceInfo.svelte";
  import Specification from "../molecules/Specification.svelte";

  interface Props {
    products: Product[];
    selectedProduct: Product | undefined;
    onClick: () => void;
  }

  let { products, selectedProduct = $bindable(), onClick }: Props = $props();

  let selectedFixedId: number | undefined = $state(
    selectedProduct && selectedProduct.type == "fixed" ? selectedProduct.id : products[0]?.id
  );
  const selectedFixed = $derived(products.find((p) => p.id === selectedFixedId));

  let disabled = $derived(!(selectedProduct && selectedProduct.type == "fixed"));

  const setProduct = (product: Product) => {
    selectedFixedId = product.id;
    if (selectedProduct?.id !== product.id) {
      selectedProduct = product;
    }
  };
</script>

<InputContainer
  {onClick}
  onChange={() => (selectedProduct = selectedFixed)}
  checked={selectedProduct && selectedProduct.type == "fixed"}
>
  <div class="flex flex-col md:flex-row md:justify-between">
    <div>
      {#if selectedFixed}
        <div>
          <span class="text-H3 mr-3">{selectedFixed.name}</span>
          {#if selectedFixed.recommended}
            <span class="tape-Green400 text-white text-H6 hidden md:inline-block"
              >REKOMMENDERAT</span
            >
          {/if}
        </div>
        {#if selectedFixed && selectedFixed.costs}
          <PriceInfo class="block md:hidden" productType="fixed" costs={selectedFixed.costs} />
        {/if}
        {#if selectedFixed.purchaseText}
          <div class="md:pt-2 purchase-text">{@html selectedFixed.purchaseText}</div>
        {/if}
      {/if}
      <div class="w-full hidden pt-3 md:flex flex-wrap text-M">
        {#each products as product (product.id)}
          <Radio
            onChange={() => setProduct(product)}
            name="fixedProduct"
            variant={disabled ? "secondary" : "primary"}
            group={selectedFixedId}
            value={product.id}
          >
            {product.length} år
          </Radio>
        {/each}
      </div>
    </div>
    {#if selectedFixed && selectedFixed.costs}
      <PriceInfo class="hidden md:block" productType="fixed" costs={selectedFixed.costs} />
    {/if}
    <div class="w-full pt-2 md:pt-3 flex text-M md:hidden justify-around">
      {#each products as product (product.id)}
        <Radio
          variant={disabled ? "secondary" : "primary"}
          name="fixedProductMobile"
          onChange={() => setProduct(product)}
          group={selectedFixedId}
          value={product.id}
        >
          {product.length} år
        </Radio>
      {/each}
    </div>
  </div>
  {#if selectedFixed}
    <Specification defaultOpen={false} product={selectedFixed} />
  {/if}
</InputContainer>
